export default __webpack_public_path__ + "static/media/ico-check.2bcc121d.png";